import { AppConfig } from './../../AppConfig';
import { Auth } from './../Auth';
import { Sms } from './../models/sms';
import { AutenticationEventType } from './../autentication.event.type';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Directive, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AutenticationService } from '../autentication.service';
import { EventTypes } from '../../shared/EventTypes';
import { setTimeout } from 'timers';

@Component({
	selector: 'app-sms-validation',
	templateUrl: './sms-validation.component.html',
	styleUrls: ['./sms-validation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SmsValidationComponent implements OnInit, OnDestroy {

	view = '[data-component="sms-validation"]';
	active = false;
	sms: Sms;
	activeInput: any;
	activeInputIndex = 0;
	smsCode = '';
	loading = false;
	sendCodeLoading = false;
	validationError = false;
	canSend = false;
	smsTry = 1;
	disabled = false;

	constructor(private authService: AutenticationService) {

	}

	ngOnInit() {

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.SMS_VALIDATION, data => {
			if (data.show) {
				this.active = true;
				this.sms = data.sms;

				const interval = setInterval(() => {
					if ($(this.view).length > 0) {
						this.show(data);
						clearInterval(interval);
					}
				}, 10);

			}
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.SMS_VALIDATION);
	}

	show(data) {

		this.smsTry = AppConfig.smsTry;

		/* $('#smsCode').pincodeInput({inputs: this.sms.size, hidedigits: false,
		complete: (value, e, errorElement) => {
			this.pinComplete();
		}}); */

		this.activeInput = $('.pincode-input-text.first');

		$('.pincode-input-text').keydown( (key) => {
		  if ($.isNumeric(key.key)) {
				this.activeInput.val(key.key);

				if (this.activeInputIndex < 5) {
					this.activeInputIndex++;
				}

				setTimeout(() => {
					this.activeInput = $($('.pincode-input-text')[this.activeInputIndex]);
				  this.activeInput.focus();
				}, 0)

		  } else if (key.key == "Backspace") {
				this.activeInput.val('');

				if (this.activeInputIndex > 0) {
					this.activeInputIndex--;
				}

				setTimeout(() => {
					this.activeInput = $($('.pincode-input-text')[this.activeInputIndex]);
					this.activeInput.focus();
				}, 0)
		  }

		  if (this.activeInputIndex == (this.sms.size - 1)) {
				this.canSend = true;
		  }
		  else {
				this.canSend = false;
		  }

		});

		TweenMax.to(this.view, .8, {delay: data.delay, left: 0, ease: Quint.easeOut});
	}

	hide() {
		TweenMax.to(this.view, .8, {left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	pinComplete() {
		// alert(' PIN COMPLETE');
	}

	getKeyboardValue(value) {

		if (this.activeInputIndex <= (this.sms.size - 1)) {
			this.activeInput.val(value[0]);
			this.activeInputIndex++;
			this.activeInput = $($('.pincode-input-text')[this.activeInputIndex]);
			this.activeInput.focus();

			if (this.activeInputIndex > (this.sms.size - 1)) {
				this.canSend = true;
			}
		}
	}

	clearInputs() {
		$('.pincode-input-text').val('');
		$('.pincode-input-text.first').focus();
		this.activeInputIndex = 0;
		this.activeInput = $('.pincode-input-text.first');
		this.canSend = false;
	}

	send() {

		if (this.canSend) {
			this.smsCode = '';
			const self = this;
			this.disabled = true;
			$('.pincode-input-text').each(function() {
				self.smsCode += $(this).val();
			});

			if (!this.loading && (this.smsCode.length === this.sms.size)) {
				this.loading = true;
				this.validationError = false;
				Auth.codigoSms = this.smsCode;
				this.authService.sendSmsCode(Auth.cpf, this.smsCode).subscribe( data => {

					this.canSend = false;
					this.loading = false;
					this.hide();
					this.disabled = false;

					if (Auth.definePassword) {
						AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.DEFINE_PASSWORD, {show: true});
					} else {
						AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.REDEFINE_PASSWORD, {show: true});
					}

				}, error => {

					this.loading = false;
					this.disabled = false;
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });

				});
			} else if (this.smsCode.length !== this.sms.size) {
				this.validationError = true;
				this.disabled = false;
			}
		}

	}

	sendCodeAgain() {
		if (!this.sendCodeLoading) {
			this.clearInputs();
			this.validationError = false;
			this.sendCodeLoading = true;
			this.authService.getSmsCode(Auth.cpf).subscribe( sms => {
				this.sendCodeLoading = false;
			});
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/sms-validation/sms-validation.component.ts